import { render, staticRenderFns } from "./CostaRicaAddressForm.vue?vue&type=template&id=2a962ca6&scoped=true"
import script from "./CostaRicaAddressForm.vue?vue&type=script&lang=js"
export * from "./CostaRicaAddressForm.vue?vue&type=script&lang=js"
import style0 from "./CostaRicaAddressForm.vue?vue&type=style&index=0&id=2a962ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a962ca6",
  null
  
)

export default component.exports